import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { initializeFirebase, auth } from './firebase';
import Login from './pages/Login';
import Browse from './pages/Browse';
import ListingDetail from './pages/ListingDetail';
import EditListing from './pages/EditListing';
import Hosting from './pages/Hosting';
import HostingDetail from './pages/HostingDetail';
import Profile from './pages/Profile';
import AccountSettings from './pages/AccountSettings';
import Saved from './pages/Saved';
import Trips from './pages/Trips';
import Navbar from './components/Navbar';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    initializeFirebase();
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <Router>
      {user && <Navbar user={user} />}
      <Routes>
        <Route path="/" element={user ? <Browse /> : <Login />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/listing/:id/edit" element={user ? <EditListing /> : <Login />} />
        <Route path="/hosting" element={user ? <Hosting /> : <Login />} />
        <Route path="/hosting/listing/:id" element={user ? <HostingDetail /> : <Login />} />
        <Route path="/profile" element={user ? <Profile /> : <Login />} />
        <Route path="/settings" element={user ? <AccountSettings /> : <Login />} />
        <Route path="/saved" element={user ? <Saved /> : <Login />} />
        <Route path="/trips" element={user ? <Trips /> : <Login />} />
      </Routes>
    </Router>
  );
}

export default App;
